import { Box, Text } from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import {
  default as Select,
  default as StateManagedSelect,
  SingleValue,
} from "react-select";
import { theme } from "../../theme";
import { OptionCustom } from "./OptionCustom";
import { SearchSelectInterface } from "./types";

interface WDSearchProps extends Omit<StateManagedSelect, "onChange"> {
  onChange: (val: string | undefined) => void;
  error?: string;
  options: SearchSelectInterface[];
  value?: string;
  placeholder?: string;
  isDisabled?: boolean;
}

export const WDSearchSelect: React.FC<WDSearchProps> = (props) => {
  const danger = theme.colors.danger[500];
  const neutralGrey = theme.colors.neutralGrey;
  const { onChange, options, error, value, ...others } = props;
  const CustomOption = (props: any) => {
    const { data, innerProps } = props;
    return (
      <OptionCustom textColor={data.color} innerProps={innerProps}>
        {data.label}
      </OptionCustom>
    );
  };

  const [selectValue, setSelectValue] = useState<
    SingleValue<SearchSelectInterface>
  >(options.filter((opt) => opt.value === value)[0] ?? null);

  const handleChange = (newValue: SingleValue<SearchSelectInterface>) => {
    setSelectValue(newValue);
  };

  useEffect(() => {
    onChange(selectValue?.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectValue]);

  useEffect(() => {
    handleChange(options.filter((opt) => opt.value === value)[0] ?? null);
  }, [value]);

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      border: `1px solid ${neutralGrey}`,
      boxShadow: "0 0 #fff",
      width: "100%",
      height: "100%",
      "&:hover": {
        border: `1px solid ${neutralGrey}`,
      },
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.data.color,
    }),

    menu: (provided: any, state: any) => ({
      ...provided,
      minWidth: "fit-content",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "100%",
      height: "100%",
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999999,
    }),
  };

  const customStylesError = {
    control: (provided: any, state: any) => ({
      ...provided,
      width: "100%",
      height: "100%",
      border: state.isFocus
        ? `1px solid ${neutralGrey}`
        : `1px solid ${danger}`,
      boxShadow: "0 0 #fff",
      "&:hover": {
        border: `1px solid ${neutralGrey}`,
      },
    }),
    container: (provided: any) => ({
      ...provided,
      width: "100%",
      height: "100%",
    }),
    menu: (provived: any, state: any) => ({
      ...provived,
      minWidth: "fit-content",
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999999,
    }),
  };

  return (
    <Box w="100%" h="100%">
      <Select
        {...others}
        isDisabled={props.isDisabled ?? false}
        components={{ Option: CustomOption }}
        options={options}
        onChange={handleChange}
        styles={error ? customStylesError : customStyles}
        value={selectValue}
        menuPortalTarget={document.body}
        menuShouldBlockScroll={true}
        menuPosition={"fixed"}
      />
      {error && <Text color={"danger.500"}>{error}</Text>}
    </Box>
  );
};
